import { render, staticRenderFns } from "./icon-folder.vue?vue&type=template&id=b74fbb46&"
import script from "./icon-folder.vue?vue&type=script&lang=js&"
export * from "./icon-folder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports